var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ExpenseTagBucketsApi } from '@ClientApi/expenseTagBucketsApi';
import { FormFieldsApi } from '@ClientApi/formFields';
import { AddCategoriesForUser, SetCategoriesLoading } from './categoriesActions';
export const ADD_EXPENSE_BUCKETS_WITH_TAGS = 'ADD_EXPENSE_BUCKETS_WITH_TAGS';
export const SET_EXPENSE_BUCKET_WITH_TAGS_LOADING = 'SET_EXPENSE_BUCKET_WITH_TAGS_LOADING';
export const SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING = 'SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING';
export const EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER = 'EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER';
export const ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID = 'ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID';
// (should be not used and removed once we will switch to use paginated API)
export class AddExpenseBucketsWithTags {
    constructor(payload) {
        this.payload = payload;
        this.type = ADD_EXPENSE_BUCKETS_WITH_TAGS;
    }
}
export class SetExpenseBucketWithTagsLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_EXPENSE_BUCKET_WITH_TAGS_LOADING;
    }
}
export class SetExpenseBucketWithTagsByIdLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING;
    }
}
export class AddExpenseBucketsForUser {
    constructor(userId, expenseBuckets) {
        this.type = EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER;
        this.payload = { userId, expenseBuckets };
    }
}
export class AddExpenseBucketsWithTagsById {
    constructor(payload) {
        this.payload = payload;
        this.type = ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID;
    }
}
export const getExpenseBucketsForUser = (userId, selectedTagIds = []) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetExpenseBucketWithTagsLoading(true));
    dispatch(new SetCategoriesLoading(true));
    const { expenseTagBuckets, categories } = yield FormFieldsApi.getSelectableBucketsAndCategories(selectedTagIds, userId);
    dispatch(new AddExpenseBucketsForUser(userId, expenseTagBuckets));
    dispatch(new AddCategoriesForUser(userId, categories));
    dispatch(new SetExpenseBucketWithTagsLoading(false));
    dispatch(new SetCategoriesLoading(false));
});
export const getExpenseTagBuckets = (forceReload = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    if (!forceReload) {
        const { expenseBucketsWithTagsLoading, dropdownExpenseBucketsWithTags } = getState().expenseBucketsWithTags;
        if (expenseBucketsWithTagsLoading || dropdownExpenseBucketsWithTags.length) {
            return;
        }
    }
    dispatch(new SetExpenseBucketWithTagsLoading(true));
    const expenseTagBuckets = yield ExpenseTagBucketsApi.getExpenseTagBucketsWithTags();
    dispatch(new AddExpenseBucketsWithTags(expenseTagBuckets));
    dispatch(new SetExpenseBucketWithTagsLoading(false));
});
export const getExpenseBucketsWithTagsById = (params = {
    includeTeamTags: false,
    includeSalesforceFilters: false,
    includeExpenseTags: false
}, forceReload = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    if (!forceReload) {
        const { expenseBucketsWithTagsByIdLoading, expenseTagBucketsById } = getState().expenseBucketsWithTags;
        if (expenseBucketsWithTagsByIdLoading || expenseTagBucketsById) {
            return;
        }
    }
    dispatch(new SetExpenseBucketWithTagsByIdLoading(true));
    const expenseTagBuckets = yield ExpenseTagBucketsApi.getExpenseTagBuckets(params.includeTeamTags, params.includeSalesforceFilters, params.includeExpenseTags);
    dispatch(new AddExpenseBucketsWithTagsById(expenseTagBuckets));
    dispatch(new SetExpenseBucketWithTagsByIdLoading(false));
});
